// extracted by mini-css-extract-plugin
export default {"facetSideDrawer":"facetSideDrawer__NGM3N"};